import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../components/BottomTabBar/BottomTabBar.css';
import './LegalInfoPage.css';

export default function LegalInfoPage() {
  const navigate = useNavigate();
  return (
    <>
      <main className="page">
        <div className="page-header">
          <h1>Правовая информация</h1>
        </div>
        <div className="menu">
          <button className="menu-item" onClick={() => window.open('https://sense-games.ru/oferta', '_blank')}>
            <div className="menu-item-content">
              <div className="menu-icon">
                <img src="/icons/legal-info-profile.svg" alt="Правовая информация" width="24" height="24" />
              </div>
              <span className="menu-label">Договор публичной оферты</span>
            </div>
            <div className="chevron">
              <img src="/icons/forward-profile.svg" alt=">" width="16" height="16" />
            </div>
          </button>
          <button className="menu-item" onClick={() => window.open('https://sense-games.ru/privacy', '_blank')}>
            <div className="menu-item-content">
              <div className="menu-icon">
                <img src="/icons/legal-info-profile.svg" alt="Правовая информация" width="24" height="24" />
              </div>
              <span className="menu-label">Политика персональных данных</span>
            </div>
            <div className="chevron">
              <img src="/icons/forward-profile.svg" alt=">" width="16" height="16" />
            </div>
          </button>
        </div>


      </main>

      <div className="tabbar-wrap" style={{ justifyContent: 'flex-start' }}>
        <button
          className="tabbar single"
          onClick={() => navigate(-1)}
          aria-label="Назад"
        >
          <img src="/icons/previous.svg" alt="Назад" />
        </button>
      </div>
    </>
  );
}